interface PolicySection {
  heading: string;
  body: string;
}

interface LegalDocumentProps {
  title: string;
  lastUpdated: string;
  sections: PolicySection[];
}

export default function LegalDocument({ title, lastUpdated, sections }: LegalDocumentProps) {
  return (
    <>
      {/* Hero */}
      <section className="relative pt-28 md:pt-36 pb-10 md:pb-14 px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 tracking-tight">
            {title}
          </h1>
          <p className="text-xs md:text-sm text-background-50/40 mt-3">
            {lastUpdated}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="px-4 md:px-6 pb-16 md:pb-24 max-w-4xl mx-auto">
        <div className="bg-background-900/60 rounded-2xl border border-background-700 p-6 md:p-10 lg:p-12 flex flex-col gap-8">
          {Array.isArray(sections) && sections.map((section, index) => (
            <article key={index}>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-background-50 mb-3">
                {section.heading}
              </h2>
              <div className="text-sm md:text-base text-background-50/70 leading-relaxed whitespace-pre-line">
                {section.body}
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}